<template>
  <div
    ref="el"
    class="w-full"
  >
    <div class="relative w-full group">
      <input
        :id="props.id"
        ref="inputEl"
        v-model="value"
        :type="props.type"
        placeholder="..."
        :class="[
          hasIcon ? 'pr-[46px]' : 'pr-[12px]',
          props.disabled ? 'bg-backgrounds-t0' : 'bg-white',
          props.invalid
            ? 'border-[#CF1B1B] focus:border-[#CF1B1B]'
            : 'border-grey-3 focus:border-grey-1'
        ]"
        :disabled="props.disabled"
        class="h-[49px] w-full text-grey-1 placeholder-transparent focus:outline-hidden border focus:ring-0 appearance-none rounded-sm pl-[12px] py-[12px] peer"
      />

      <label
        :for="props.id"
        class="peer-focus:text-sm z-10 peer-focus:top-0 peer-placeholder-shown:text-lg peer-placeholder-shown:top-[50%] duration-300 bg-white px-1 left-[12px] -translate-y-1/2 text-grey-2 absolute text-sm"
        @click="labelClick"
      >
        {{ props.label }}
      </label>

      <div
        v-if="hasIcon"
        class="absolute top-1/2 right-[12px] -translate-y-1/2"
      >
        <slot name="icon"></slot>
      </div>
    </div>
  </div>
</template>

<script setup>
// vue utils
import { computed, ref, useSlots, watch } from 'vue'

const props = defineProps({
  id: {
    type: String,
    required: true
  },
  label: {
    type: String
  },
  modelValue: {
    required: true
  },
  type: {
    default: 'text',
    required: false
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false
  },
  invalid: {
    type: Boolean,
    required: false,
    default: false
  }
})

const emit = defineEmits(['update:modelValue', 'update:valid'])

const value = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val)
})

const slots = useSlots()

const inputEl = ref(null)

const hasIcon = computed(() => !!slots.icon)

const labelClick = () => inputEl.value.focus()
</script>
